export default __webpack_public_path__ + "static/media/close-white.97dbc91e.svg";